/**
 * @fileoverview Shared local-calendar input built on AppTextInput. Workspaces own the selected date, validation and persistence; the control emits a Date/null value envelope. Calendar dates keep local midnight instead of passing through UTC. AppDateInput provides the direct-value callback counterpart.
 */
import React from 'react';
import AppTextInput from './AppTextInput';
import { formatDateForInput, parseDateInput } from './utils';

function inputValue(value, showTime) {
  const day = formatDateForInput(value);
  if (!day || !showTime) return day;
  const date = new Date(value);
  return `${day}T${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
}

export default function AppCalendar({ value, onChange, inputId, id, disabled, className, style, minDate, maxDate,
  placeholder, showTime, readOnlyInput, showIcon, showButtonBar, dateFormat, ...props }) {
  return <AppTextInput type={showTime ? 'datetime-local' : 'date'} id={inputId || id}
    value={inputValue(value, showTime)} disabled={disabled} className={className} style={style}
    min={inputValue(minDate, showTime)} max={inputValue(maxDate, showTime)} placeholder={placeholder}
    aria-label={props['aria-label']} aria-labelledby={props['aria-labelledby']}
    onChange={event => onChange?.({ value: showTime ? event.target.value ? new Date(event.target.value) : null : parseDateInput(event.target.value), originalEvent: event })} />;
}
export { AppCalendar as Calendar };
